import { ICourseGroup } from "../typings/IGroup";
import http from "./client"
import { IListResponse } from "./types";

export interface IByAuthroQueryParams {
  limit: number;
  page?: number;
  search?: string;
  course_id?: string | number;
  onlyAuthor?: boolean;
  atpay?: boolean;
  searchOnlyName?: boolean;
}

interface IByAuthorResponse {
  data: Array<ICourseGroup>
}

async function byAuthor(queryParams: IByAuthroQueryParams): Promise<IListResponse<ICourseGroup>> {
  const response = await http.get<IListResponse<ICourseGroup>>(`/api/group/by-author`, {
    params: queryParams
  });
  return response.data;
}
async function byId(id: number) {

  const res = await http.get('/api/coursegroup/group', {
    params: {
      group_id: id,
    }
  })

  return res.data;
}
const coursesGroups = {
  byAuthor, byId,

}

export default coursesGroups;